import React, { useState, useEffect } from 'react';
import CampaignList from '../CampaignList/CampaignList';
import CampaignAdsDetails from '../CampaignAdsDetails/CampaignAdsDetails';
import "./CampaignHome.css"
import { FetchCampaigns } from '../../../Api/CampaignApi';

export default function CampaignHome(props) {
    const [campaignList, setCampaignList] = useState([]); // List of ads
    const [refresh, setRefresh] = useState(false); // Default active filter
    const [isLoading, setIsLoading] = useState(true); // Default active filter
    const [campaignStatus, setCampaignStatus] = useState('All'); // Default active filter
    const [clickedCardId, setClickedCardId] = useState(null);

    const [campaignSearchQuery, setCampaignSearchQuery] = useState(); // Search Bar Input


    useEffect(() => {
        const storedId = localStorage.getItem("activeCampaignId");
        if (storedId) {
            setClickedCardId(JSON.parse(storedId));
        }
    }, []);

    const FetchCampaignData = async () => {
        try {
            const campaignListArray = await FetchCampaigns({
                SearchList: [{
                    ClientId: props.clientId,
                    Status: campaignStatus === "All" ? null : campaignStatus,
                    Title: campaignSearchQuery ?? null

                    // createdByUser: JSON.parse(localStorage.getItem("userId")),
                }],
                SortList: [{ FieldName: "startCampaignDate", Direction: "DESC" }]
            });


            // Transform data to include campaignDate
            const transformedCampaignList = campaignListArray.map(campaign => ({
                ...campaign,
                campaignDate: {
                    start: new Date(campaign.startCampaignDate),
                    end: new Date(campaign.endCampaignDate)
                }
            }));

            setCampaignList(transformedCampaignList);
            setIsLoading(false)

            // Set clickedCardId to the first campaign if not set
            if (!clickedCardId && transformedCampaignList.length > 0) {
                setClickedCardId(transformedCampaignList[0].id);
            } else if (clickedCardId && !transformedCampaignList.some(campaign => campaign.id === clickedCardId)) {
                setClickedCardId(transformedCampaignList[0].id);
            }

        } catch (error) {
            console.log(error);
        }
    };

    React.useEffect(() => {
        // setIsLoading(true);
        FetchCampaignData();
    }, [campaignStatus, refresh, campaignSearchQuery]);


    return (
        !isLoading && <div style={{
            display: 'flex',
            height: "100vh",
            width: "100vw"
        }}>

            <div className="campaign-list-wrapper">
                <CampaignList
                    campaignList={campaignList}
                    clickedCardId={clickedCardId}
                    setClickedCardId={setClickedCardId}

                    campaignStatus={campaignStatus}
                    setCampaignStatus={setCampaignStatus}
                    toggleRefresh={() => setRefresh(!refresh)}
                    campaignSearchQuery={campaignSearchQuery}
                    setCampaignSearchQuery={setCampaignSearchQuery}
                    {...props}
                />
            </div>
            <div className='campaign-ads-details-wrapper'>
                {clickedCardId && campaignList.length > 0 ? (
                    <CampaignAdsDetails
                        detail={campaignList.find((ad) => ad.id === clickedCardId) || campaignList[0].id}
                        toggleRefresh={() => setRefresh(!refresh)}
                        {...props} />
                ) : <div className="no-campaigns">Please select a Campaign</div>}

            </div>
        </div>
    );
}

